<template>
  <div>
    <el-menu
      :default-active="$route.path"
      class="el-menu-demo"
      v-if="viewWidth >= 554"
      router
      mode="horizontal"
      background-color="#FFF"
      active-text-color="#1a1a1a"
      text-color="#1a1a1a"
    >
      <div class="headImg"><img src="../../assets/img/logo.png" alt="" /></div>
      <el-menu-item index="/homes" class="titfir">{{
        $t("navbar.HOME")
      }}</el-menu-item>
      <el-menu-item index="/journal" class="titfir">{{
        $t("navbar.JOURNALS")
      }}</el-menu-item>
      <el-submenu index="1" class="titfir">
        <template slot="title">{{ $t("navbar.BOOKS") }}</template>
        <div class="titsco">
          <el-menu-item index="/chineseItem?type=1">{{
            $t("navbar.Academic")
          }}</el-menu-item>
          <el-menu-item index="/chineseItem?type=2">{{
            $t("navbar.Literary")
          }}</el-menu-item>
          <el-menu-item index="/chineseItem?type=3">{{
            $t("navbar.Translated")
          }}</el-menu-item>
        </div>
      </el-submenu>
      <el-submenu index="2" class="titfir">
        <template slot="title">{{ $t("navbar.ABOUT") }}</template>
        <div class="titsco">
          <el-menu-item index="/aboutus">{{
            $t("navbar.ABOUTUS")
          }}</el-menu-item>
          <el-menu-item index="/newsItem">{{ $t("navbar.NEWS") }}</el-menu-item>
        </div>
      </el-submenu>
      <el-submenu index="3" class="titfir">
        <template slot="title">{{ $t("navbar.BusinessScope") }}</template>
        <div class="titsco">
          <el-menu-item index="/manuscript?type=8">{{
            $t("navbar.Optimization")
          }}</el-menu-item>
          <el-menu-item index="/manuscript?type=9">{{
            $t("navbar.Translat")
          }}</el-menu-item>
          <el-menu-item index="/manuscript?type=10">{{
            $t("navbar.Manuscript")
          }}</el-menu-item>
          <el-menu-item index="/pdfItem">{{
            $t("navbar.Electronic")
          }}</el-menu-item>
          <el-menu-item index="/manuscript?type=11">{{
            $t("navbar.GoogleRankings")
          }}</el-menu-item>
        </div>
      </el-submenu>
      <el-menu-item index="/contactItem" class="titfir">{{
        $t("navbar.CONTACT")
      }}</el-menu-item>
      <!-- <div class="langage" v-if="viewWidth >= 554">
        <span @click="toggleLang('zh')"> 中文</span>|<span
          @click="toggleLang('en')"
          >English</span
        >
      </div> -->
    </el-menu>
    <div v-if="viewWidth < 554" class="mobile_nav_wrap">
      <div class="navbar_left">
        <img src="../../assets/img/logo.png" />
      </div>
      <div class="navbar_right">
        <!-- <div class="langage">
          <span @click="toggleLang('zh')"> 中文</span>|<span
            @click="toggleLang('en')"
            >English</span
          >
        </div> -->
        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
      <div v-if="isCollapse == true" class="nav_menu" ref="menu">
        <router-link class="menu_item" to="/homes">{{
          $t("navbar.HOME")
        }}</router-link>
        <router-link class="menu_item" to="/journal">{{
          $t("navbar.JOURNALS")
        }}</router-link>
        <div class="menu_item" @click="changeBOOKShow">
          {{ $t("navbar.BOOKS") }}<i class="el-icon-arrow-down"></i>
        </div>
        <div class="item_optionss" v-show="BOOKShow">
          <router-link to="/chineseItem?type=1">{{
            $t("navbar.Academic")
          }}</router-link>
          <router-link to="/chineseItem?type=2">{{
            $t("navbar.Literary")
          }}</router-link>
          <router-link to="/chineseItem?type=3">{{
            $t("navbar.Translated")
          }}</router-link>
        </div>
        <div class="menu_item" @click="changeABOUTShow">
          {{ $t("navbar.ABOUT") }}<i class="el-icon-arrow-down"></i>
        </div>
        <div class="item_options" v-show="ABOUTShow">
          <router-link to="/aboutus">{{ $t("navbar.ABOUTUS") }}</router-link>
          <router-link to="/newsItem">{{ $t("navbar.NEWS") }}</router-link>
        </div>
        <div class="menu_item" @click="changeBusinessShow">
          {{ $t("navbar.BusinessScope") }}<i class="el-icon-arrow-down"></i>
        </div>
        <div class="item_optionsss" v-show="BusinessShow">
          <router-link to="/manuscript?type=8">{{
            $t("navbar.Optimization")
          }}</router-link>
          <router-link to="/manuscript?type=9">{{
            $t("navbar.Translat")
          }}</router-link>
          <router-link to="/manuscript?type=10">{{
            $t("navbar.Manuscript")
          }}</router-link>
          <router-link to="/pdfItem">{{ $t("navbar.Electronic") }}</router-link>
          <router-link to="/manuscript?type=11">{{
            $t("navbar.GoogleRankings")
          }}</router-link>
        </div>
        <router-link class="menu_item" to="/contactItem">{{
          $t("navbar.CONTACT")
        }}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: "0",
      viewWidth: window.innerWidth,
      isCollapse: false,
      BOOKShow: false,
      ABOUTShow: false,
      BusinessShow: false,
    };
  },
  watch: {
    $route() {
      this.isCollapse = false; // 路由变化时自动收起菜单
      this.BOOKShow = false;
      this.ABOUTShow = false;
      this.BusinessShow = false;
    },
  },
  methods: {
    fun(val) {
      this.$router.push(val);
    },
    changeBOOKShow() {
      this.BOOKShow = !this.BOOKShow;
      this.ABOUTShow = false;
      this.BusinessShow = false;
    },
    changeABOUTShow() {
      this.ABOUTShow = !this.ABOUTShow;
      this.BOOKShow = false;
      this.BusinessShow = false;
    },
    changeBusinessShow() {
      this.BusinessShow = !this.BusinessShow;
      this.ABOUTShow = false;
      this.BOOKShow = false;
    },
    //切换方法
    toggleLang(lang) {
      this.$i18n.locale = lang;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    moveMenu() {
      this.isCollapse = !this.isCollapse;
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav_menu {
  position: absolute;
  width: 100%;
  height: 450px;
  list-style: none;
  left: 0;
  right: 0;
  top: 56px;
  padding-bottom: 0;
  box-sizing: border-box;
  background: #eff0f1;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  z-index: 10;
  transition: all 0.8s;
  .menu_item {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 0.9rem;
    font-weight: 700;
    background: #eff0f1;
    color: #1c212d;
    padding: 0.2rem;
    display: flex;
    align-items: center;
  }
  .item_options {
    width: 100%;
    padding: 5px 10px;
    height: 52px;
    font-size: 0.8rem;
    font-weight: 700;
    background: #fff;
    a {
      display: inline-block;
      width: 100%;
      color: #666;
      height: 25%;
      padding: 20px 30px;
    }
  }
  .item_option {
    width: 100%;
    padding: 5px 10px;
    height: 22rem !important;
    font-size: 0.8rem;
    font-weight: 700;
    background: #fff;
    a {
      display: inline-block;
      width: 100%;
      color: #666;
      height: 8%;
      padding: 0.2rem 0.3rem;
    }
  }
  .item_options {
    width: 100%;
    padding: 5px 10px;
    height: 60px;
    font-size: 0.8rem;
    font-weight: 700;
    background: #fff;
    a {
      display: inline-block;
      width: 100%;
      color: #666;
      height: 50%;
      padding: 0.1rem;
    }
  }
  .item_optionss {
    width: 100%;
    padding: 5px 10px;
    height: 80px;
    font-size: 0.8rem;
    font-weight: 700;
    background: #fff;
    a {
      display: inline-block;
      width: 100%;
      color: #666;
      height: 30%;
      padding: 0.1rem;
    }
  }
  .item_optionsss {
    width: 100%;
    padding: 5px 10px;
    height: 150px;
    font-size: 0.8rem;
    font-weight: 700;
    background: #fff;
    a {
      display: inline-block;
      width: 100%;
      color: #666;
      height: 18%;
      padding: 0.1rem;
    }
  }
}
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56px;
  background: #fff;
  z-index: 1000;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  .navbar_left {
    flex: 1;
    // background: #fff;
    img {
      height: 2.5rem;
      width: 12rem;
    }
    h1 {
      width: 200px !important;
      font-size: 1.5rem;
      margin-left: 20px;
      color: #181717;
      @media screen and (max-width: 1500px) {
        font-size: 1rem;
      }
    }
  }
  .navbar_right {
    flex: 2;
    height: 56px;
    display: flex;
    justify-content: flex-end;
    background: #fff;
    .langage {
      width: 88px;
      height: 100%;
      // background: #1a63c4;
      // color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.58rem;
    }

    .nav_btns {
      width: 56px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 30px;
      }
    }
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.pulish {
  font-size: 0.4rem !important;
}

.headImg {
  img {
    height: 1.5rem;
    width: 8rem;
  }
}

.langage {
  font-size: 0.25rem;
  cursor: pointer;
}

::v-deep .el-menu-demo {
  display: flex;
  justify-content: space-between;
}

::v-deep .titfir {
  width: 10%;
  font-size: 0.28rem;
  height: 1.55rem;
  line-height: 1.55rem;
  text-align: center;
}

::v-deep .el-menu--horizontal .el-submenu .el-submenu__title {
  height: 1.55rem;
  line-height: 1.55rem;
  font-size: 0.28rem;
  text-align: center;
}

::v-deep .el-menu--horizontal .el-menu-item {
  height: 1.55rem;
  line-height: 1.55rem;
  font-size: 0.28rem;
  text-align: center;
}

.titsco {
  width: 5rem;
}

::v-deep .el-menu-demo .is-active {
  font-size: 0.3rem;
  height: 1.55rem;
  line-height: 1.55rem;
  font-weight: 700;
  border: none;
}

::v-deep .el-submenu .is-active {
  font-size: 0.3rem;
  height: 1.55rem;
  line-height: 1.55rem;
  font-weight: 700;
  border: none;
}

::v-deep .el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 5rem !important;
}
@media screen and (max-width: 1180px) {
  .headImg {
    display: contents;

    img {
      height: 1.5rem;
      width: 6rem;
    }
  }
}
@media screen and (max-width: 854px) {
  .headImg {
    display: contents;

    img {
      height: 1.3rem;
      width: 4rem;
    }
  }

  ::v-deep .el-menu-demo {
    height: 1.3rem;
    line-height: 1.3rem;
    justify-content: flex-start;
  }

  ::v-deep .el-menu--collapse .el-menu .el-submenu,
  .el-menu--popup {
    min-width: 1.3rem !important;
  }

  ::v-deep .titfir .el-submenu__title {
    height: 1.3rem !important;
    width: 50px;
    line-height: 1.3rem !important;
    background-color: #fff;
    font-size: 0.5rem !important;
  }

  ::v-deep .el-menu--horizontal .el-menu-item {
    height: 1.3rem !important;
    width: 50px;
    line-height: 1.3rem !important;
    font-size: 0.5rem !important;
  }

  ::v-deep .el-menu-demo .is-active {
    height: 1.3rem;
    line-height: 1.3rem;
    font-size: 0.5rem !important;
    font-weight: 700 !important;
  }

  ::v-deep .el-submenu .is-active .is-opened {
    height: 1.3rem;
    line-height: 1.3rem;
    font-size: 0.5rem !important;
    font-weight: 700 !important;
  }
}
</style>
